export default __webpack_public_path__ + "static/BundesSans-Web-RegularItalic-910e23d641121de3f3c456ee5b8f4ced.woff";